<script setup lang="ts">
import { useId } from 'vue';
import BasicIcon from '@/components/elements/basic/BasicIcon.vue';

const {
  text,
  icon = 'mdi-help-circle',
  size = '16px'
} = defineProps<{
  text: string;
  icon?: string;
  size?: string;
}>();

const anchorId = `help-tooltip-${useId()}`;
</script>

<template>
  <basic-icon
    :id="anchorId"
    tabindex="0"
    class="ml-1 help-tooltip-trigger"
    :size="size"
    color="color-text-tertiary"
    data-testid="help-tooltip-trigger"
    :aria-label="text">
    {{ icon }}
  </basic-icon>
  <!-- as-popover renders in the top layer, so the tooltip shows above Miranda dialogs too -->
  <m-tooltip as-popover :anchor="anchorId" placement="bottom">{{ text }}</m-tooltip>
</template>
